import { useState } from "react";
import { toast } from "react-toastify";
import { uploadImageServcie } from "services/CRUDServices";

import { base64ToFile, fileToBase64 } from "tools/functions/Methods";
import { PreviewImage } from "../types";



export const useFileUpload = (
  onComplete: (ids: string[]) => void,
  mode: "single" | "multiple"
) => {
  const [uploadingFiles, setUploadingFiles] = useState<Set<number>>(new Set());

  const uploadFile = async (
    file: File,
    index: number,
    setPreviews: React.Dispatch<React.SetStateAction<PreviewImage[]>>
  ) => {
    setUploadingFiles((prev) => new Set(prev).add(index));

    try {
      const base64 = await fileToBase64(file);
      const fileBlob = base64ToFile(base64, file.name);
      
      const formData = new FormData();
      formData.append("file", fileBlob);

      const { data } = await uploadImageServcie(
        "/storage-api/indexed-objects/FREELANCER/as-file",
        "post",
        formData
      );

      setPreviews((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index], id: data.response?.id };

        const allIds = updated.map(img => img.id).filter((id): id is string => !!id);
        
        if (allIds.length === updated.length) {
          onComplete(allIds);
        }

        return updated;
      });

      toast.success(`${file.name} آپلود شد`);
    } catch (error) {
      toast.error(`خطا در آپلود ${file.name}`);
      setPreviews((prev) => prev.filter((_, i) => i !== index));
    } finally {
      setUploadingFiles((prev) => {
        const updated = new Set(prev);
        updated.delete(index);
        return updated;
      });
    }
  };

  return { uploadFile, uploadingFiles };
};
